<template>
    <div class="content-wrapper">
      <div class="row">
        <div class="col-sm-12 col-md-6">
          <app-breadcrumb
            :page-title="$t('saved_responses')"
            :directory="$t('datatables')"
            :icon="'grid'"
          />
        </div>
        <div class="col-sm-12 col-md-6 breadcrumb-side-button">
          <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
             <button
              type="button"
              class="btn btn-primary btn-with-shadow"
              data-toggle="modal"
              @click="openResponseCategoryModal">
              {{ $t("create_response_category") }}
            </button>
          </div>
        </div>
      </div>
  
      <app-table :id="tableId" :options="options" @action="getListAction" />

      <save-response-form-modal
        v-if="isSaveResponseFormModalActive"
        :type="formType"
        :formBody="formBody"
        :formRevisionId="formRevisionId"
        :formID="formID"
        :user_id="user_id"
        @close-modal="closeSaveResponseFormModal"
        />

        <save-response-category-addmodal
          v-if="isAddResponseCategoryModalActive"
          :tableId="tableId"
          @close-modal="closeAddResponseCategoryModal"
        />

        <save-response-category-importmodal
          v-if="isSaveResponseCategoryImportModalActive"
          :tableId="tableId"
          :formRevisionId="formRevisionId"
          @close-modal="closeSaveResponseCategoryImportModal"
        />

    </div>
  </template>
  
  <script>
  import CoreLibrary from "../../../../../core/helpers/CoreLibrary.js";
  import * as actions from "../../../../Config/ApiUrl";
  import { TableHelpers } from "../../Demo/Tables/mixins/TableHelpers";
  import {axiosPost} from "@/app/Helpers/AxiosHelper";
  import {RESPONSE_DELETE} from "../../../../Config/ApiUrl";
  
  export default {
    extends: CoreLibrary,
    name: "SavedResponses",
    mixins: [TableHelpers],
    data() {
      return {
        formType: '',
        formBody: 0,
        formRevisionId: 0,
        formID: 0,
        user_id: 0,
        isSaveResponseFormModalActive: false,
        isAddResponseCategoryModalActive: false,
        isSaveResponseCategoryImportModalActive: false,
        selectedUrl: "",
        tableId: "saved_responses",
        rowData: {},
        options: {
          name: "AdvanceTable",
          url: actions.SAVED_RESPONSES_LIST,
          // url: actions.DATATABLE_DATA,
          showHeader: true,
          columns: [
            {
                title: this.$t("name"),
                type: "custom-html",
                key: "get_forms",
                modifier: (value,row) => {
                return `<a class="text-primary cursor-pointer" id="${row.id+'_'+row.form_id+'_'+row.form_body_id}"  @click.prevent=${this.myFunction(row)}>${this.$t(value.name ?? "---")}</a>`;
                },
            },
            {
                title: this.$t("description"),
                type: "custom-html",
                key: "get_forms",
                modifier: (value) => {

                return `<span>${this.$t(value.description ?? "---")}</span>`;
                },
            },
            {
                title: this.$t("category"),
                type: "custom-html",
                key: "response_category",
                modifier: (value,row) => {
                return `<span>${this.$t(value != null ? value.response_category_name.name : "---")}</span>`;                
                },
            },
            {
              title: this.$t("Created By"),
              type: "custom-html",
              key: "user",
              modifier: (value,row) => {
                return `<span>${this.$t(value != null ? value.full_name : "---")}</span>`;
              },
            },
            {
              title: this.$t("Created At"),
              type: "custom-html",
              key: "created_at",
              modifier: (value) => {
                var date = moment(value).format("YYYY-MM-DD hh:mm");
                return `<span>${this.$t(date)}</span>`;
              },
            },
            // {
            //   title: this.$t("status"),
            //   type: "custom-html",
            //   key: "status",
            //   isVisible: true,
            //   modifier: (value) => {
            //     let ClassName = "danger";
  
            //     if (value === "completed") ClassName = `success`;
            //     else if (value === "incomplete") ClassName = `warning`;
            //     else if (value === "action_required") {
            //       ClassName = `info`; value = 'Action Required';}
  
            //     return `<span class="badge badge-sm badge-pill badge-${ClassName}">${this.$t(
            //       value
            //     )}</span>`;
            //   },
            // },
          ],
          actions: [
            {
              title: this.$t("edit"),
              icon: "edit",
              type: "none",
              component: "app-add-modal",
              modalId: "demo-add-edit-Modal",
            },
            {
              title: this.$t("view"),
              icon: "eye",
              type: "none",
              component: "app-add-modal",
              modalId: "demo-add-edit-Modal",
            },
            {
              title: this.$t("response_category"),
              icon: "upload",
              type: "none",
            },
            {
              title: this.$t("delete_response"),
              icon: "trash",
              type: "none",
            },
          ],
          filters: [
        //     {
        //       title: this.$t("date"),
        //       type: "range-picker",
        //       key: "date",
        //       option: ["today", "thisMonth", "last7Days", "nextYear"],
        //     },
        //     {
        //       title: this.$t("priority"),
        //       type: "checkbox",
        //       key: "priority",
        //       option: [
        //         { id: "low", value: "Low" },
        //         { id: "medium", value: "Medium" },
        //         { id: "high", value: "High" },
        //       ],
        //     },
        //     {
        //       title: this.$t("status"),
        //       type: "checkbox",
        //       key: "status",
        //       option: [
        //         { id: "completed", value: "Completed" },
        //         { id: "incomplete", value: "Incomplete" },
        //         // {id: 'invited', value: 'Invited'},
        //       ],
        //     },
            {
              "title": this.$t('search_by_category'),
              "type": "drop-down-filter",
              "key": "search select",
              "option": [],
            }
          ],
          showFilter: true,
          showSearch: true,
          showCount: true,
          showClearFilter: true,
          paginationType: "pagination",
          responsive: true,
          rowLimit: 10,
          showAction: true,
          orderBy: "desc",
          actionType: "dropdown",
        },
      };
    },
    created() {
      this.options.columns = [...this.options.columns, this.actionObj];
      this.searchAndSelectFilterOptions();
    },
    methods: {
      deleteResponse(rowData){
        // Display a confirmation dialog
        const isConfirmed = window.confirm('Are you sure you want to delete this response?');

        // If the user confirms, proceed with the deletion
        if (isConfirmed) {
          axiosPost(RESPONSE_DELETE, {selfResponse: rowData})
              .then((res) => {
                this.$toastr.s(res.data.message);
              })
              .catch((error) => {
                this.$toastr.e(error.response.data.message ?? error.message);
              })
              .finally(() => {
                this.$hub.$emit('reload-' + this.tableId);
                // Additional cleanup or logic after deletion
              });
        }
        // If the user cancels, do nothing or handle accordingly
      },
        openSaveResponseFormModal() {
            this.isSaveResponseFormModalActive = true;
        },
        closeSaveResponseFormModal() {
            $("#save_response_form_modal").modal("hide");
            this.isSaveResponseFormModalActive = false;
        },
        getListAction(rowData, actionObj, active) {
            this.rowData = rowData;
            if (actionObj.title == this.$t("view")) {
                // this.formID = rowData.form_id;
                this.view(rowData);
            } 
            else if (actionObj.title == this.$t("edit")) {
                if (rowData.self == 1) {
                    this.formType = 'save_response';
                    this.formBody = rowData.form_body_id;
                    this.formRevisionId = rowData.id;
                    this.formID = rowData.form_id;
                    this.openSaveResponseFormModal();
                }
                else {
                    this.updateFormRevision(rowData);
                }
            }
            else if(actionObj.title == this.$t("response_category")) {
              if (rowData.response_category != null) {
                  var category_name = rowData.response_category.response_category_name.name;
                  this.$toastr.i('This form is already inside in '+category_name);
              }
              else {
                  this.formRevisionId = rowData.id;
                  this.openSaveResponseCategoryImportModal();
              }
            }
            else if(actionObj.title == this.$t("delete_response")) {
              this.deleteResponse(rowData)
            }
            else {
                this.$toastr.w('You can not use this action for this document');
            }
        },
        view(rowData) {
            this.formBody = rowData.form_body_id;
            this.formID = rowData.form_id;
            this.formRevisionId = rowData.id;
            this.user_id = rowData.created_by;
            this.formType = 'save-response-view';
            this.openSaveResponseFormModal();
        },
        myFunction(rowData){
            let doc = document.getElementById(rowData.id+'_'+rowData.form_id+'_'+rowData.form_body_id);
            if(doc){
                doc.addEventListener('click', () => {
                this.view(rowData);
                })
            }
        },
        updateFormRevision(rowData) {
        this.axiosGet(actions.UPDATE_FORM_REVISION_SELF +'/'+ rowData.id)
            .then((res) => {
                if (res.data.type == 'success') {
                    this.formType = 'save_response';
                    this.formBody = rowData.form_body_id;
                    this.formRevisionId = rowData.id;
                    this.formID = rowData.form_id;
                    this.openSaveResponseFormModal();
                }
            })
            .catch((error) => {

            });
        },

        openResponseCategoryModal() {
          this.isAddResponseCategoryModalActive = true;
        },
        closeAddResponseCategoryModal() {
          $("#demo-add-response-category-modal").modal("hide");
          this.isAddResponseCategoryModalActive = false;
          this.searchAndSelectFilterOptions();
        },

        openSaveResponseCategoryImportModal() {
          this.isSaveResponseCategoryImportModalActive = true;
        },
        closeSaveResponseCategoryImportModal() {
          $("#demo-save-response-category-import-modal").modal("hide");
          this.isSaveResponseCategoryImportModalActive = false;
        },

        searchAndSelectFilterOptions() {
          this.axiosGet(actions.RESPONSE_CATEGORY_FILTER_LIST).then((response) => {
            let name = this.options.filters.find(
              (element) => element.title === this.$t("search_by_category")
            );
            name.option = response.data.map((name) => {
              return {
                id: name.id,
                value: name.value,
              };
            });
          });
        },
    },
  };
  </script>
  